import PostType, { CampaignType } from 'constants/postType.constants';
import { first, isEmpty, trim } from 'lodash-es';
import { hashtagsToDisplay } from './hashtagParser';

const trimText = (text, targetLength = 80) => {
  let trimmedText = '';

  if (text) {
    if (text.length > targetLength) {
      const sentences = text.split(/[?!\n]/); // Split by ?, !, and carriage return
      let firstSentence = trim(sentences[0]);

      if (firstSentence.length > targetLength) {
        const words = firstSentence.split(' ');
        let truncatedSentence = '';

        for (let i = 0; i < words.length; i++) {
          const tempSentence = truncatedSentence + words[i] + ' ';
          if (tempSentence.length > targetLength) {
            break;
          }
          truncatedSentence = tempSentence;
        }

        firstSentence = `${truncatedSentence}...`;
      }

      trimmedText = firstSentence.substring(0, targetLength);
    } else {
      trimmedText = trim(text);
    }
  }

  return trimmedText;
};


export const defaultOpenGraphMeta = {
  type: 'website',
  locale: 'en_US',
  site_name: 'Neki',
};

export const getPostPageTitle = (post) => {
  const titleParts = [`${post.renderProps.company.name} | Neki`];
  switch (post.sourcePostType) {
    case PostType.Volunteering:
      titleParts.push('Volunteer');
      titleParts.push(post.renderProps.title);
      break;
    case PostType.Campaign:
      if (post.sourcePostData.campaignType === CampaignType.FundRaise) {
        titleParts.push('Fundraiser');
      } else if (
        post.sourcePostData.campaignType === CampaignType.CollectGoods
      ) {
        titleParts.push('In-Kind Fundraiser');
      }
      titleParts.push(post.renderProps.title);
      break;
    case PostType.Celebration:
      titleParts.push('Celebration');
      const recipientNames = post.sourcePostData.recipients
        .map((recipient) => {
          return `${recipient.firstName} ${recipient.lastName}`;
        })
        .join(', ');
      const title = `${recipientNames} ${post.renderProps.title}`;
      titleParts.push(trimText(title, 80));
      break;
    default:
      titleParts.push(trimText(post.renderProps.title, 80));
      break;
  }

  let title = titleParts.filter((part) => !isEmpty(part)).join(' - ');
  title = hashtagsToDisplay(title)
    .map((item) => item.displayText)
    .join(' ');

  // Remove HTML tags using a regular expression
  const cleanedTitle = title.replace(/<[^>]*>/g, '');

  return cleanedTitle;
};

export const getPostPageDescription = (post) => {
  let description = post.renderProps.description;

  if (!description || !description.length) {
    description = post.renderProps?.nonProfit?.description || '';
  }
  description = trimText(description, 156);

  // Remove HTML tags using a regular expression
  const cleanedDescription = description.replace(/<[^>]*>/g, '');

  return cleanedDescription;
};
